export type Location = {
  uuid?: string
  city: string
  state: string
  lat?: number | string
  lng?: number | string
  timestamp: string
  source:
    | 'project-44'
    | 'trucker-tools'
    | 'edi-platform-core'
    | 'loads-app'
    | 'quick-track'
    | 'shipper-guide-user'
}

export function isManualLocation({ source }: Location) {
  return source === 'shipper-guide-user'
}
